
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { Class } from '@/types/classTypes';

interface ScheduleHeaderProps {
  currentClass: Class | null;
  onAddScheduleClick: () => void;
}

const ScheduleHeader: React.FC<ScheduleHeaderProps> = ({ 
  currentClass, 
  onAddScheduleClick 
}) => {
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-bold">
        {currentClass ? `Schedule for ${currentClass.name}` : 'Class Schedules'}
      </h2>
      <Button 
        className="bg-rosterly-purple hover:bg-rosterly-purple/90"
        onClick={onAddScheduleClick}
      >
        <Plus className="mr-2 h-4 w-4" /> Add Schedule
      </Button>
    </div>
  );
};

export default ScheduleHeader;
